import React, { memo, useEffect, useState } from "react";
import TextFieldMui from "@mui/material/TextField";
import { useField } from "formik";
import styled from "@emotion/styled";
import {
  InputFieldProps,
  T_BASE_INPUT_PROPS
} from "../input-field/InputField";
import { usePropagateRef } from "../../../hooks/usePropagateRef";
import { useYupContext } from "../../../context/RequiredFields.context";
import { Tooltip } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface TextAreaFieldProps extends InputFieldProps {
  radius_px?: number;
}

const TextAreaField: React.FC<any> = React.forwardRef(
  (props, ref: any) => {
    const { name, msgTooltip, isRequired, ...rest } = props;
    const [field, meta] = useField({ name: name });
    const [fieldValue, setFieldValue] = useState<string | number>(
      field.value
    );
    const { requiredFields } = useYupContext();
    const error = !!meta.error && meta.touched;
    const className = `${props.className} ${
      requiredFields[props.name!] || props.isRequired ? "required" : ""
    }`;
    usePropagateRef({
      setFieldValue,
      name: name,
      value: field.value
    });
    useEffect(() => {
      if (meta.touched) {
        // return;
      }
      if (field.value !== fieldValue) {
        setFieldValue(field.value);
      }
    }, [field.value]);
    const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
      setFieldValue(evt.target.value);
    };
    /**update formik when out field */
    const onBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
      const val: any = fieldValue || "";
      window.setTimeout(() => {
        field.onChange({
          target: {
            name: name,
            value: props.type === "number" ? parseInt(val, 10) : val
          }
        });
      }, 0);
    };

    const CONFIG_FIELD: T_BASE_INPUT_PROPS = {
      ...rest,
      ...field,
      name: name,
      value: fieldValue,
      onChange,
      onBlur,
      fullWidth: true,
      size: "small",
      autoComplete: "none",
      className: className,
      error,
      helperText: error ? meta.error : "",
      multiline: true,
      rows: props.rows ?? 4
    };
    return (
      <Container ref={ref}>
        <Input {...CONFIG_FIELD} name={props.name || ""} />
        {msgTooltip && (
          <Tooltip title={msgTooltip} children={<CustomIconInfo />} />
        )}
      </Container>
    );
  }
);

export default memo(TextAreaField);

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;
const Input = styled(TextFieldMui)((props: TextAreaFieldProps) => {
  return `
  & .MuiInputBase-input {
    font-size: 13px !important;
    font-weight: 600;
  }
  label {
    color: var(--m-color-blue-03);
    font-weight: 700;
    font-family: var(--ff-inter);
    font-size: var(--fs-placeholder);
  }
  & ::placeholder {
    padding: 10px 5px;
    color: var(--m-color-gray-03);
    font-weight: 200;
    font-family: var(--ff-inter);
    font-size: var(--fs-text-x-small);
    opacity: 0.8;
  }
   & .MuiFormHelperText-root {
      color: var(--m-color-red-01) !important;
      opacity: 0.8;
      font-size: 11px;
    }
  & .MuiOutlinedInput-root {
    border-radius: ${props.radius_px ? props.radius_px : 20}px;
  }
`;
});

const CustomIconInfo = styled(ErrorOutlineIcon)`
  font-size: 0.8rem;
  color: var(--m-color-blue-03);
`;
